// extracted by mini-css-extract-plugin
var _1 = "Editor-module__animateUploadProgressBarWidth--eOl7V";
var _2 = "Editor-module__animatedBackground--6s0z7";
var _3 = "Editor-module__contentContainer--cq0J4";
var _4 = "Editor-module__editor--TlGgg";
var _5 = "Editor-module__hasBanner--yYVNP";
var _6 = "Editor-module__isPublic--_NMy3";
var _7 = "data-placeholder";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "contentContainer", _4 as "editor", _5 as "hasBanner", _6 as "isPublic", _7 as "placeholderAttribute" }
